module.exports = __webpack_public_path__ + "img/6.c44009d2.png";